import { Card } from "../../../../../components/Card";
import { Text } from "@chakra-ui/react";

function ClimateActionDescription() {
  return (
    <Card>
      <Text marginBottom={5}>
        Climate policy refers to policy instruments governments around the world are going to enforce in line with their net-zero commitments.
      </Text>
      <Text marginBottom={5}>
        Tracking climate policies provides insight into how governments seek to decarbonise and meet their climate goals/ targets made under the Paris Agreement. It therefore provides key details surrounding how these policy instruments will impact your business, alongside the timelines of such policies. The policies will be a mix of subsidies (e.g., industrial use of hydrogen) and/or taxes.
      </Text>

      <Text marginBottom={5}>
        Following the numerous net zero pledges that have been made globally, countries have brought forward a wide range of policies and plans to help realise their net-zero targets.
      </Text>
      <Text marginBottom={5}>
        UK - Net Zero Strategy (released 2021) provides a narrative on how the UK intends to meet its net-zero goal and achieve carbon neutrality.
      </Text>
      <Text marginBottom={5}>
        EU – Fit for 55 refers to the EU’s target of reducing net greenhouse gas emissions by at least 55% by 2030.
      </Text>
      <Text>
        US – Inflation Reduction Act (IRA) is the largest climate legislation in US history and relates to new federal spending toward reducing carbon emissions.
      </Text>
    </Card>
  )
}

export default ClimateActionDescription;